import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CollateralAssetCodeApprvService from "services/Setup/Master/collateralAssetCodeApprvService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  collateralAssetCodeApprvList: {},
};

export const getCollateralAssetCodeApprvList = createAsyncThunk(
  "collateralAssetCodeApprv/getCollateralAssetCodeApprvList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralAssetCodeApprvService.getCollateralAssetCodeApprvList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const collateralAssetCodeApprv = createSlice({
  name: "collateralAssetCodeApprv",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get collateralAsset code list
      .addCase(getCollateralAssetCodeApprvList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCollateralAssetCodeApprvList.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralAssetCodeApprvList = action.payload;
      })
      .addCase(getCollateralAssetCodeApprvList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  collateralAssetCodeApprv.actions;

export default collateralAssetCodeApprv.reducer;
